/* eslint-disable no-underscore-dangle */

import { useFragment, graphql } from 'react-relay';
import { useTranslation } from '@/helpers/translate';
import Skin1 from '@/components/space/card-skin1.js';

const query = graphql`
  fragment cardCms_item on Space @argumentDefinitions (
    lang: {type:"String!"}
  ) {
    ...cardSkin1_item @arguments(lang: $lang)
    dataByCategory {
      price {
        amount_excl_tax
      }
    }
  }
`;

function CardCms({ item }) {
  const { t } = useTranslation();
  if (!item) return null;
  return (
    <Skin1 {...{
      item,
      options: {
        lvl0: 'relative cursor-pointer',
        contentPrice: !item?.dataByCategory?.price?.amount_excl_tax ? null : (
          <span className="z-10 text-[16px]">
            {item?.dataByCategory?.price?.amount_excl_tax}
            {t('form:label.euro_per_day')}
          </span>
        ),
      },
    }}
    />
  );
}

export default function RootComponent({ item: itemData, ...props }) {
  const item = itemData?.__id ? useFragment(query, itemData || null) : itemData;

  return <CardCms {...{ item }} {...props} />;
}
